import { render, staticRenderFns } from "./PopupDetail.vue?vue&type=template&id=65d25d8d&"
import script from "./PopupDetail.vue?vue&type=script&lang=ts&"
export * from "./PopupDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports